// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"accaac6f","551":"2273cb59","842":"b7d8d9f8","851":"2f1eab74"}[chunkId] + ".chunk.js";
};